<template>
    <div v-if="showBottomError" @click="dismiss()">
        <div class="main-text">
            <p>{{errorMessage}}</p>
            <div class="dismiss-button">Ok</div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'TopicError',

        computed: {
            ...mapState([
                'showBottomError',
                'errorMessage'
            ])
        },

        methods: {
            dismiss() {
                this.$store.commit('showBottomError', false);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .main-text{
        position: fixed;
        top: 95vh;
        right: 0px;
        margin: auto;
        width: 100vw;
        background: rgba(255, 36, 36, 0.7);
        border-radius: 5px;
        display: block;
        padding: 8px 15px;
        text-align: center;
        bottom: -100px;
        z-index: 9999;
        color: rgb(255, 255, 255);

        &:hover{
            cursor: pointer;
        }
    }

    .dismiss-button{
        padding: 4px;
        font-weight: 600;
    }
</style>